module.exports = __webpack_public_path__ + "img/35b)(Kempinski Hotel St. Moritz)Montage der gesamten Gästezimmer.jpg";